export default __webpack_public_path__ + "static/vitro__negro-c9a9d4a74f62954578abbd2f456bdc0d.png";